import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import type { ShopMedia } from '@/lib/api/shop-media-api'
import { ListPageHeader } from '@/components/common/ListPageHeader'
import {
    MediaBrowser,
    MediaDetailSheet,
    MediaDropZone,
} from '@/components/media'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

// Bán lẻ › Thư viện ảnh: mọi ảnh / video dùng ở website + Mini App (nội dung,
// danh mục, nhóm, trang chủ). Kéo thả hoặc "Tải lên" nhiều file; bấm một file
// để sửa alt, xem nơi đang dùng, xoá (bị chặn khi còn dùng).
export const Route = createFileRoute('/_app/_authed/_sidebar/retail/media')({
    component: MediaLibraryPage,
})

export function MediaLibraryPage() {
    const { hasPermission } = useAuth()
    const [open, setOpen] = useState<ShopMedia | null>(null)
    return (
        <div className="space-y-4">
            <ListPageHeader
                title={m.media_nav()}
                subtitle={m.media_page_description()}
            />
            <MediaDropZone className="p-1">
                <MediaBrowser
                    selected={open ? new Set([open.id]) : undefined}
                    onPick={setOpen}
                />
            </MediaDropZone>
            <MediaDetailSheet
                item={open}
                onClose={() => setOpen(null)}
                canWrite={hasPermission('shop_content.write')}
            />
        </div>
    )
}
